var map = {
	"./Close-white.svg": 65673,
	"./chevron-dark.svg": 49393,
	"./chevron-light.svg": 90455,
	"./chevron-white.svg": 91260,
	"./chevron.svg": 5772,
	"./file/3ds.svg": 72268,
	"./file/aac.svg": 71389,
	"./file/ai.svg": 35594,
	"./file/avi.dark.svg": 67464,
	"./file/avi.svg": 84126,
	"./file/bmp.svg": 41553,
	"./file/cad.svg": 23652,
	"./file/cdr.svg": 31709,
	"./file/css.svg": 34405,
	"./file/csv.dark.svg": 63002,
	"./file/csv.svg": 3000,
	"./file/dat.svg": 50323,
	"./file/default.svg": 96727,
	"./file/dll.svg": 76612,
	"./file/dmg.svg": 29756,
	"./file/doc.dark.svg": 89628,
	"./file/doc.svg": 33578,
	"./file/docx.dark.svg": 51976,
	"./file/docx.svg": 73118,
	"./file/eps.svg": 26118,
	"./file/fla.svg": 11675,
	"./file/flv.svg": 12324,
	"./file/gif.dark.svg": 3140,
	"./file/gif.svg": 47746,
	"./file/html.dark.svg": 41363,
	"./file/html.svg": 63199,
	"./file/indd.svg": 74125,
	"./file/iso.svg": 15839,
	"./file/jpg.dark.svg": 29193,
	"./file/jpg.svg": 10245,
	"./file/js.svg": 31205,
	"./file/json.dark.svg": 12920,
	"./file/json.svg": 45678,
	"./file/key.dark.svg": 87969,
	"./file/key.svg": 73837,
	"./file/md.dark.svg": 10495,
	"./file/md.svg": 87075,
	"./file/midi.svg": 8323,
	"./file/mov.dark.svg": 94320,
	"./file/mov.svg": 18358,
	"./file/mp3.svg": 35198,
	"./file/mp4.dark.svg": 22941,
	"./file/mp4.svg": 95105,
	"./file/mpg.svg": 33954,
	"./file/pdf.dark.svg": 71388,
	"./file/pdf.svg": 35466,
	"./file/php.svg": 38408,
	"./file/png.dark.svg": 73657,
	"./file/png.svg": 79413,
	"./file/ppt.svg": 81148,
	"./file/pptx.dark.svg": 7062,
	"./file/pptx.svg": 91596,
	"./file/ps.svg": 34483,
	"./file/psd.svg": 49301,
	"./file/rar.dark.svg": 17203,
	"./file/rar.svg": 85695,
	"./file/raw.svg": 41858,
	"./file/sql.svg": 80812,
	"./file/svg.dark.svg": 10092,
	"./file/svg.svg": 80858,
	"./file/tif.svg": 28073,
	"./file/txt.dark.svg": 78538,
	"./file/txt.svg": 51336,
	"./file/unknown.dark.svg": 21936,
	"./file/unknown.svg": 94473,
	"./file/webm.dark.svg": 62407,
	"./file/webm.svg": 88987,
	"./file/webp.dark.svg": 19768,
	"./file/webp.svg": 4078,
	"./file/wmv.svg": 32054,
	"./file/xls.dark.svg": 36651,
	"./file/xls.svg": 10215,
	"./file/xlsx.svg": 90493,
	"./file/xml.dark.svg": 21183,
	"./file/xml.svg": 42723,
	"./file/zip.dark.svg": 7793,
	"./file/zip.svg": 47357,
	"./icons/alert-triangle.svg": 30285,
	"./icons/chevron-gradient-dark.svg": 23393,
	"./icons/chevron-gradient.svg": 47388,
	"./icons/chevron-right-white.svg": 46662,
	"./icons/close.svg": 75126,
	"./icons/done.svg": 71154,
	"./icons/doubleDone.svg": 48397,
	"./icons/drag.svg": 43784,
	"./icons/gray-check.svg": 33136,
	"./icons/green-check.svg": 51444,
	"./icons/import-jira-team.svg": 37224,
	"./icons/jira-icon.svg": 73624,
	"./icons/play.svg": 7840,
	"./icons/resize.svg": 45758,
	"./icons/white-check-dark.svg": 23591,
	"./icons/white-check.svg": 96222,
	"./icons/x-circle.svg": 25691,
	"./logo-dark.svg": 53067,
	"./logo.svg": 3914,
	"./logo2.svg": 18516,
	"./play-bttn.svg": 67898,
	"./plus.svg": 91363,
	"./staging-logo-dark.svg": 58535,
	"./staging-logo.svg": 98878,
	"./svg/accounts.svg": 30259,
	"./svg/add-file-24.svg": 68814,
	"./svg/add-file.svg": 75659,
	"./svg/add.svg": 12392,
	"./svg/addMark.svg": 71203,
	"./svg/addUserInTeam.svg": 82619,
	"./svg/advance-settings.svg": 13875,
	"./svg/ai-activity-dislike.svg": 94123,
	"./svg/ai-activity-like.svg": 64375,
	"./svg/ai-config.svg": 73516,
	"./svg/alert-tooltip.svg": 76193,
	"./svg/alert-triangle.svg": 40108,
	"./svg/alert.svg": 21487,
	"./svg/alertSprint.svg": 86239,
	"./svg/alertSprint2.svg": 15695,
	"./svg/align-center.svg": 30724,
	"./svg/align-justify.svg": 19773,
	"./svg/align-left.svg": 57808,
	"./svg/align-right.svg": 41631,
	"./svg/archive-epics.svg": 5762,
	"./svg/archive.svg": 72179,
	"./svg/arrow-go-back.svg": 38939,
	"./svg/arrow-go-forward.svg": 28941,
	"./svg/arrow-long.svg": 21633,
	"./svg/arrow-to.svg": 77140,
	"./svg/arrow-up.svg": 5648,
	"./svg/arrow.svg": 12886,
	"./svg/arrowBacklog.svg": 42735,
	"./svg/arrowUpdate.svg": 30609,
	"./svg/attach.svg": 28208,
	"./svg/attention.svg": 34943,
	"./svg/backlog-icon.svg": 53478,
	"./svg/backlog-item-24.svg": 93199,
	"./svg/backlogAge/counter-0.svg": 63251,
	"./svg/backlogAge/counter-1.svg": 41730,
	"./svg/backlogAge/counter-2.svg": 78449,
	"./svg/backlogAge/counter-3.svg": 42496,
	"./svg/backlogAge/counter-4.svg": 8383,
	"./svg/backlogAnalytics.svg": 73388,
	"./svg/backlogSort.svg": 7824,
	"./svg/bar-chart.svg": 96141,
	"./svg/bell.svg": 61244,
	"./svg/billing-notification.svg": 21816,
	"./svg/bold.svg": 8502,
	"./svg/calendar-full-in-row.svg": 44484,
	"./svg/calendar-full.svg": 7449,
	"./svg/calendar-late.svg": 85162,
	"./svg/calendar-unavailable.svg": 70572,
	"./svg/calendar.svg": 93657,
	"./svg/cards-view.svg": 87598,
	"./svg/case.svg": 88879,
	"./svg/chart-backlog.svg": 49459,
	"./svg/chartSprint.svg": 65401,
	"./svg/chat-gpt.svg": 21957,
	"./svg/check-list.svg": 60498,
	"./svg/check.svg": 97649,
	"./svg/checkbox-checked.svg": 47252,
	"./svg/checkbox-unchecked.svg": 1615,
	"./svg/chevron-blue.svg": 6989,
	"./svg/chevron-gradient.dark.svg": 93737,
	"./svg/chevron-gradient.svg": 21477,
	"./svg/chevron-light.svg": 20575,
	"./svg/chevron-plan.svg": 30356,
	"./svg/chevron-with-paddings.svg": 50976,
	"./svg/chevron.svg": 22100,
	"./svg/circle-parts.svg": 33286,
	"./svg/clock-full-dark.svg": 49856,
	"./svg/clock-full.svg": 57667,
	"./svg/clock.svg": 9435,
	"./svg/close.svg": 1133,
	"./svg/close2.svg": 72005,
	"./svg/close3-dark.svg": 98201,
	"./svg/close3.svg": 74756,
	"./svg/closeWithBg.dark.svg": 42890,
	"./svg/closeWithBg.svg": 5704,
	"./svg/code-box.svg": 3376,
	"./svg/completed.svg": 39546,
	"./svg/continuous-sprint.svg": 65355,
	"./svg/continuousHaltSprint.svg": 94179,
	"./svg/copy-link.svg": 8993,
	"./svg/copy.svg": 45176,
	"./svg/credit-card.svg": 36739,
	"./svg/cycle.svg": 20031,
	"./svg/danger.svg": 9158,
	"./svg/demo-requests.svg": 17369,
	"./svg/disable-user.svg": 81555,
	"./svg/done.svg": 60311,
	"./svg/dot-crosed.svg": 51603,
	"./svg/dots-horizontal-bottom.svg": 30776,
	"./svg/dots-horizontal-center.svg": 88838,
	"./svg/double-quotes.svg": 73166,
	"./svg/doubleCheck.svg": 34116,
	"./svg/download.svg": 51031,
	"./svg/edit.svg": 42463,
	"./svg/email.svg": 36769,
	"./svg/epic-details.svg": 53905,
	"./svg/epic-notification.svg": 65468,
	"./svg/epic.svg": 75804,
	"./svg/estimation-methodology.svg": 7712,
	"./svg/expand-btn.svg": 3568,
	"./svg/expand-open.svg": 92656,
	"./svg/expand-top.svg": 92577,
	"./svg/expand.svg": 69775,
	"./svg/expandClose.svg": 7281,
	"./svg/external-jira-link.svg": 9192,
	"./svg/external-link.svg": 59383,
	"./svg/external-link2.svg": 43447,
	"./svg/face-happy.svg": 35517,
	"./svg/face-normally.svg": 48589,
	"./svg/face-sadness.svg": 18274,
	"./svg/favorite-filled-dark.svg": 66713,
	"./svg/favorite-filled.svg": 27140,
	"./svg/favorite-folder.svg": 19600,
	"./svg/favorite.svg": 19995,
	"./svg/feature-icon.svg": 56695,
	"./svg/file-del.svg": 96549,
	"./svg/file.svg": 46789,
	"./svg/filter.svg": 19393,
	"./svg/flag.svg": 76809,
	"./svg/fold-top.svg": 40480,
	"./svg/fold.svg": 88002,
	"./svg/folder.svg": 41355,
	"./svg/font-color.svg": 62878,
	"./svg/format-clear.svg": 16170,
	"./svg/gear.svg": 54198,
	"./svg/gearAlert.svg": 87048,
	"./svg/goal-complete.svg": 34302,
	"./svg/goal-icon.svg": 50160,
	"./svg/goals-close.svg": 51866,
	"./svg/gradient-chevron.dark.svg": 24137,
	"./svg/gradient-chevron.svg": 62181,
	"./svg/gradient-slash.svg": 74735,
	"./svg/h1.svg": 22938,
	"./svg/h2.svg": 38025,
	"./svg/happy-smile.svg": 92700,
	"./svg/history-icon.svg": 83397,
	"./svg/history-timesheet-dark.svg": 85979,
	"./svg/history-timesheet.svg": 93658,
	"./svg/history.svg": 80113,
	"./svg/iconAlert.svg": 36918,
	"./svg/idea-24.svg": 52802,
	"./svg/idea-plus.svg": 34795,
	"./svg/idea-vote-16.svg": 76393,
	"./svg/idea-vote-dislike-filled.svg": 44586,
	"./svg/idea-vote-dislike-outline.svg": 57932,
	"./svg/idea-vote-filled.svg": 49588,
	"./svg/idea-vote-outline.svg": 39742,
	"./svg/idea.svg": 38514,
	"./svg/image-not-found.svg": 43721,
	"./svg/import.svg": 30088,
	"./svg/imported.svg": 93571,
	"./svg/info-tooltip.svg": 73061,
	"./svg/info.svg": 45571,
	"./svg/integrations.svg": 34362,
	"./svg/italic.svg": 79683,
	"./svg/item-analytics.svg": 23465,
	"./svg/jira-icon.svg": 69115,
	"./svg/jira-sync.svg": 58009,
	"./svg/lamp.svg": 38229,
	"./svg/layout.svg": 5417,
	"./svg/lightbulb.svg": 63696,
	"./svg/link-off.svg": 70039,
	"./svg/link-on.svg": 47259,
	"./svg/link-open.svg": 37216,
	"./svg/link.svg": 36607,
	"./svg/list-ordered.svg": 92643,
	"./svg/list-unordered-v2.svg": 30725,
	"./svg/list-unordered.svg": 12012,
	"./svg/list.svg": 42327,
	"./svg/llm.svg": 93716,
	"./svg/loader.svg": 65914,
	"./svg/lock.svg": 14490,
	"./svg/logout.svg": 47797,
	"./svg/loupe.svg": 10592,
	"./svg/mail.svg": 11414,
	"./svg/max-screen.svg": 86716,
	"./svg/maxscreen.svg": 95867,
	"./svg/menu-dot.svg": 56188,
	"./svg/menu-epics-24.svg": 690,
	"./svg/menu-player-btn-story-in-row.svg": 56458,
	"./svg/menu-player-btn-story.svg": 88027,
	"./svg/menu-player-btn.svg": 13579,
	"./svg/menu-player-sprint-btn.svg": 47926,
	"./svg/menu.svg": 76674,
	"./svg/menu2.svg": 71740,
	"./svg/message-question-dark.svg": 40826,
	"./svg/message-question.svg": 46553,
	"./svg/message-smile-dark.svg": 5128,
	"./svg/message-smile.svg": 31387,
	"./svg/milestoneIcon.svg": 38260,
	"./svg/minscreen.svg": 91205,
	"./svg/more-teams.svg": 4577,
	"./svg/more-vertical.svg": 52071,
	"./svg/my-teams.svg": 45148,
	"./svg/my-work-checkbox.svg": 61125,
	"./svg/new-tab.svg": 46397,
	"./svg/next-in-line.svg": 34927,
	"./svg/office.svg": 82007,
	"./svg/open-in-new-tab.svg": 13290,
	"./svg/openInNewTab.svg": 46157,
	"./svg/paperplane.svg": 51311,
	"./svg/pdf.svg": 34211,
	"./svg/pen.svg": 80260,
	"./svg/permission-settings.svg": 19924,
	"./svg/photo.svg": 25949,
	"./svg/play-button.svg": 47098,
	"./svg/play-demo.svg": 27483,
	"./svg/play-not-found.svg": 18154,
	"./svg/play-timestamp.svg": 65794,
	"./svg/play.svg": 31317,
	"./svg/plus-16.svg": 20697,
	"./svg/plus-circle.svg": 52632,
	"./svg/plus.svg": 92539,
	"./svg/postMortem.svg": 29433,
	"./svg/product-backlog-menu-icon.svg": 5800,
	"./svg/product-backlog.svg": 1470,
	"./svg/project-24.svg": 43649,
	"./svg/push.svg": 72507,
	"./svg/quality-gates.svg": 16025,
	"./svg/quote-double.svg": 86173,
	"./svg/raceFlag.svg": 63458,
	"./svg/refresh.svg": 45568,
	"./svg/reply-icon-lg.svg": 42361,
	"./svg/reply-icon.svg": 94429,
	"./svg/resize.svg": 32327,
	"./svg/retrospective-done.svg": 75071,
	"./svg/retrospective.svg": 91082,
	"./svg/review-dark.svg": 71996,
	"./svg/review.svg": 91751,
	"./svg/roadmap-columns.svg": 46111,
	"./svg/roadmap-goal-24.svg": 21006,
	"./svg/roadmap-goal.svg": 88363,
	"./svg/roadmap.svg": 57685,
	"./svg/run.svg": 33434,
	"./svg/scraper.svg": 61115,
	"./svg/scrumHaltSprint.svg": 96418,
	"./svg/separator.svg": 30360,
	"./svg/settings.svg": 29340,
	"./svg/severityLevel.svg": 94860,
	"./svg/share.svg": 96820,
	"./svg/skip-back-after.svg": 11260,
	"./svg/skip-back-before.svg": 37526,
	"./svg/smile.svg": 36553,
	"./svg/sorting.svg": 74177,
	"./svg/spinner-gradient-dark.svg": 2684,
	"./svg/spinner-gradient.svg": 49959,
	"./svg/spinner.svg": 97038,
	"./svg/sprint-24.svg": 83486,
	"./svg/sprint-alert.svg": 59134,
	"./svg/sprint-info-arrow.svg": 52620,
	"./svg/sprintAnalytics.svg": 27701,
	"./svg/start.svg": 43489,
	"./svg/stop.svg": 27979,
	"./svg/story-poker-notification.svg": 61550,
	"./svg/storyPoker.svg": 96689,
	"./svg/strike.svg": 89593,
	"./svg/success.svg": 5684,
	"./svg/suggested.svg": 19336,
	"./svg/summaries-dark.svg": 37150,
	"./svg/summaries.svg": 98645,
	"./svg/switch.svg": 29175,
	"./svg/sync-setting.svg": 61293,
	"./svg/t-short.svg": 47296,
	"./svg/table.svg": 60297,
	"./svg/table2.svg": 29881,
	"./svg/tag.svg": 96469,
	"./svg/task-breakdown.svg": 88126,
	"./svg/task-check-list.svg": 48324,
	"./svg/task-icon.svg": 12082,
	"./svg/team-add.svg": 19854,
	"./svg/team-noAvatar.svg": 34191,
	"./svg/team-type-development.svg": 42989,
	"./svg/team-type-devops.svg": 80929,
	"./svg/team-type-marketing.svg": 86390,
	"./svg/team-type-ui_ux.svg": 95488,
	"./svg/team-unassigned.svg": 10928,
	"./svg/team.svg": 60464,
	"./svg/teams-multiproject.svg": 88638,
	"./svg/teams.svg": 3059,
	"./svg/text-wrap.svg": 39511,
	"./svg/theme.svg": 87394,
	"./svg/time-dark.svg": 92853,
	"./svg/time.svg": 56712,
	"./svg/timesheets.svg": 29992,
	"./svg/todo-icon.svg": 31351,
	"./svg/todo-review.svg": 63280,
	"./svg/trash.svg": 7147,
	"./svg/triangle_left.svg": 35181,
	"./svg/triangle_right.svg": 67184,
	"./svg/underline.svg": 30377,
	"./svg/unfold.svg": 84927,
	"./svg/unlink.svg": 82042,
	"./svg/upload-image-dark.svg": 80681,
	"./svg/upload-image.svg": 5972,
	"./svg/upload.svg": 58680,
	"./svg/upload2.svg": 28634,
	"./svg/user-add.svg": 35440,
	"./svg/user.svg": 82925,
	"./svg/users.svg": 58725,
	"./svg/usersPage.svg": 69308,
	"./svg/warningIcon.svg": 510,
	"./svg/waterline.dark.svg": 42604,
	"./svg/waterline.svg": 47258,
	"./svg/x-circle.svg": 2342,
	"./svg/x-circleRed.svg": 21283,
	"./svg/xls.svg": 18334,
	"./svg/zero-sprint.svg": 90882,
	"./svg/zoom-in.svg": 61486,
	"./svg/zoom-out.svg": 63497,
	"./uploadImage.svg": 53735,
	"./vector.svg": 96146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90743;